import { useEffect, useRef, useState } from 'react'

type UseOrderDetailSkeletonVisibilityInput = {
  loading: boolean
  minVisibleMs?: number
}

export const useOrderDetailSkeletonVisibility = ({
  loading,
  minVisibleMs = 920,
}: UseOrderDetailSkeletonVisibilityInput) => {
  const [visible, setVisible] = useState(() => loading)
  const loadingStartedAtRef = useRef<number | null>(loading ? Date.now() : null)

  useEffect(() => {
    if (loading) {
      loadingStartedAtRef.current = Date.now()
      setVisible(true)
      return
    }

    if (!visible) return

    const startedAt = loadingStartedAtRef.current ?? Date.now()
    const elapsed = Date.now() - startedAt
    const remaining = Math.max(minVisibleMs - elapsed, 0)

    const timeoutId = window.setTimeout(() => {
      setVisible(false)
      loadingStartedAtRef.current = null
    }, remaining)

    return () => window.clearTimeout(timeoutId)
  }, [loading, minVisibleMs, visible])

  return visible
}
